export default "__VITE_ASSET__CLvQRU1d__"